export default "__VITE_ASSET__iVzMFL6$__"